<template>
  <b-card
    class="offer"
  >
    <table>
      <tr>
        <th>Proto</th>
        <td>{{offer.protoId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>State</th>
        <td>{{offer.state | getOfferStateName}}</td>
      </tr>
      <tr>
        <th>Start</th>
        <td>{{offer.startStamp | getMomentStr}}</td>
      </tr>
      <tr>
        <th>Finish</th>
        <td>{{offer.finishStamp | getOptionalTextMomentStr('not finished')}}</td>
      </tr>
    </table>

  </b-card>
</template>

<script>
export default {
  name: 'PlayerOfferSimple',

  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
};
</script>
